import { getFont } from '@24i/nxg-sdk-higgs';
import { Theme } from '@24i/nxg-sdk-photon';

const TechnicalInfoScreen = (theme: Theme) => ({
    description: {
        color: theme.color.textPrimary,
        marginBottom: 32,
        opacity: 0.8,
        ...getFont(theme, 'body1'),
        fontSize: 14,
    },
    descriptionLandscape: {
        marginHorizontal: 32,
        width: '57%',
    },
    itemsWrapper: {},
    title: {
        color: theme.color.textPrimary,
        ...getFont(theme, 'h4'),
        marginBottom: 8,
    },
    itemWrapper: {
        borderRadius: 10,
        padding: 16,
        width: '100%',
        backgroundColor: theme.color.lighter4,
        marginBottom: 16,
    },
});

export default TechnicalInfoScreen;
